import { ProtectedRoute } from 'layout/components/protected-route'
import { APP_NAME, ROUTE_LABELS } from 'layout/constants/route-labels'
import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

// List of public routes that don't require authentication
const PUBLIC_ROUTES = [
  '/signin',
  '/signup',
  '/forgot-password',
  '/reset-password',
]

interface AppLayoutProps {
  children: React.ReactNode
}

export default function AppLayout({ children }: AppLayoutProps) {
  const location = useLocation()
  const pathname = location.pathname

  useEffect(() => {
    const label = ROUTE_LABELS[pathname]
    document.title = label ? `${label} | ${APP_NAME}` : APP_NAME
  }, [pathname])

  // Check if current path is public
  const isPublicRoute = PUBLIC_ROUTES.includes(pathname)

  // If it's a public route, render without protection
  if (isPublicRoute) {
    return <>{children}</>
  }

  // If it's a protected route, wrap with ProtectedRoute
  return <ProtectedRoute>{children}</ProtectedRoute>
}
